import React from 'react';
import './Logo.css'
import logo from '../../assets/img/logo_anim.svg';
import logo1 from '../../assets/img/logo-nose.svg'
import logo2 from '../../assets/img/logo-tem.svg';

const Logo = props => (
    <div style={{
        margin: "0 auto",
        height: 'inherit',
        display: !props.show ? 'block' : 'none',
    }}>
        <img id="logoLoader" src={typeof InstallTrigger !== 'undefined' ? logo2 : logo}
             style={{
                 width: "100%",
                 display: !props.show ? 'block' : 'none',
                 objectFit: 'contain',
                 height: 'inherit',
                 maxHeight: '700px',
                 maxWidth: '700px',
                 margin: "0 auto"
             }}
        />
    </div>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/logo/Logo.js